module.exports = __webpack_public_path__ + "img/shang.b0002b2f.jpg";